<script>
export default {
    data() {
        return {
            activeIndex: 0,
            loopCounter: null
        };
    },

    mounted() {
        this.activeIndex = Number(this.data.initial);
    },

    methods: {
        setActvePoint(index, isManual) {
            this.activeIndex = index;
            if (this.loopCounter && isManual) clearInterval(this.loopCounter);
        },

        openNextSlide() {
            if (this.activeIndex === this.data.list.length - 1) {
                this.setActvePoint(0, false);
            } else {
                this.setActvePoint(this.activeIndex + 1, false);
            }
        },

        initLoop() {
            this.loopCounter = setInterval(() => {
                this.openNextSlide();
            }, 3000);
        },

        blockVisibilityChanged(isVisible) {
            if (!isVisible) return;

            this.initLoop();
        }
    }
};
</script>
